import _ from 'underscore';
import { edmCampaign } from '@bingads-webui/edm-campaign';
import { mockedTag } from './mocked-data';

export function getErrorMessage(errorCode, i18n) {
  const defaultMessage = i18n.getString(_TL_('We\'ve encountered an error while saving this tag. Please try again or contact support for assistance.'));
  const messageMap = {
    TagWithSameNameAlreadyExistsUnderCustomer: i18n.getString(_TL_('A tag with this name already exists. Enter a different name.')),
    InvalidTagName: i18n.getString(_TL_('We can\'t save the UET tag because the name has invalid characters. Enter a different name and try again.')),
    TagNameNullOrEmpty: i18n.getString(_TL_('We can\'t save the UET tag because the name has invalid characters. Enter a different name and try again.')),
    InvalidTagDescription: i18n.getString(_TL_('We can\'t save the UET tag because either the description has invalid characters or is too long. Enter a different description and try again.')),
    MaxUetTagPerCustomerLimitReached: i18n.getString(_TL_('You have reached maximum UET tags')),
    CustomerUnderMigration: i18n.getString(_TL_('Conversion tracking tags and goals data is currently being migrated to a better system. Please try again later.')),
    SharedLibraryUserPermissionDenied: i18n.getString(_TL_('You don\'t have permission.')),
    UpdateFailedForIsClarityTagEnabled: i18n.getString(_TL_('Your UET tag is saved except for \'Enable Microsoft Clarity\'. Please try again later.ou don\'t have permission')),
    UniversalPixelCannotLinkToTwoTags: i18n.getString(_TL_('Universal Pixel can only be linked to one UET tag.')),
  };

  return messageMap[errorCode] || defaultMessage;
}

export function getTag(cid, aid, tagId) {
  if (cid && aid) {
    return edmCampaign
      .Customers.$withKey(cid)
      .Accounts.$withKey(aid)
      .Tag.$withKey(tagId)
      .get({}).toPromise();
  }
  return new Promise((resolve) => {
    resolve(mockedTag);
  });
}

const createTag = (cid, aid, payload) => {
  if (cid) {
    const edmCustomer = edmCampaign.Customers.$withKey(cid);
    const edmHolder = aid ? edmCustomer.Accounts.$withKey(aid) : edmCustomer;
    return edmHolder.Tags.post(payload).toPromise()
      .then((response) => {
        if (response && response.Id) {
          // log tag created
          return { Id: response.Id };
        }
        throw new Error('Couldn\'t create the tag');
      });
  }
  return new Promise((resolve) => {
    const mockResp = { Id: 234235 };
    resolve(mockResp);
  });
};

const updateTag = (cid, aid, tagId, payload) => {
  if (cid) {
    const edmCustomer = edmCampaign.Customers.$withKey(cid);
    const edmHolder = aid ? edmCustomer.Accounts.$withKey(aid) : edmCustomer;
    return edmHolder.Tags.update(tagId, payload)
      .then((response) => {
        if (response.Id) {
          // log tag saved
          return response;
        }
        throw response;
      });
  }
  return new Promise((resolve) => {
    const mockResp = { Id: 234235 };
    resolve(mockResp.Id);
  });
};

const processPayload = (tagContext) => {
  const payload = _.defaults(
    {
      Name: tagContext.Name,
      Description: tagContext.Description || '',
    },
    _.isNumber(tagContext.IsClarityTagEnabled) ? { IsClarityTagEnabled: tagContext.IsClarityTagEnabled } : null,
    _.isBoolean(tagContext.IsWebInsightsEnabled) ? { IsWebInsightsEnabled: tagContext.IsWebInsightsEnabled } : null,
    tagContext.selectedSharingOption ? { Owner: tagContext.Owner } : null,
    tagContext.selectedSharingOption
      ? {
        SharingScope: tagContext.SharingScope || {
          Customers: [],
          Accounts: [],
          Others: 0,
          Total: 0,
        },
      }
      : null,
    !tagContext.Id && tagContext.InvestUniversalPixel // don't include this field in edit scenario
      ? { InvestUniversalPixel: tagContext.InvestUniversalPixel }
      : null
  );

  return payload;
};

export const saveTag = (tagContext, scope, serverContext) => {
  const tagId = tagContext.Id;
  const { cid, aid } = scope.values || {};
  let customerId = cid;
  if (_.isFinite(aid)) {
    // customer level Tag belongs to scope cid; account level tag should use advcid
    const { CurrentAccount: currentAccount } = serverContext;
    customerId = currentAccount.AdvertiserCustomerID;
    if (!customerId) {
      throw new Error('customer Id is undefined');
    }
  }
  const payload = processPayload(tagContext);
  if (!tagId) {
    return createTag(customerId, aid, payload);
  }
  // edit scenario
  return updateTag(customerId, aid, tagId, payload);
};
